/* eslint-disable */
// Based on https://www.w3.org/TR/wai-aria-practices-1.1/#carousel. Progressively enhances child `<ol>`s into Accessible Slick sliders (https://github.com/Accessible360/accessible-slick)

class Carousel {
    constructor() {
        this.instances = $('[data-progressive-enhancement="off"][data-progressive-enhancement-type="carousel"]');
    }

    init(helpers) {
        const self = this;

        self.helpers = helpers;

        self.enhanceAll(self);
    }

    enhance(instance, self) {
        let $headingDeepestElement,
            $instance = $(instance),
            $ol = $instance.children('ol'),
            $slick,
            leftCaretSvg,
            leftCaretSvgPath,
            rightCaretSvgPath,
            rightCaretSvg,
            xmlns = 'http://www.w3.org/2000/svg';

        if(2 > $ol.children().length) {
            return;
        }

        $ol.children('li').each(function() {
            self.helpers.changeHTMLTag(this, 'DIV');
        });

        $ol = $(self.helpers.changeHTMLTag($ol[0], 'DIV'));

        $slick = $ol.slick({
            arrowsPlacement: 'afterSlides',
            dots: true,
            infinite: false
        });

        leftCaretSvgPath = document.createElementNS(xmlns, 'path');
        leftCaretSvgPath.setAttribute('d', 'm23.559 5.77-2.286-2.36L8.356 16.742l12.917 13.333 2.286-2.36-10.63-10.973 10.63-10.974Z');
        leftCaretSvgPath.setAttribute('fill', 'currentColor');

        leftCaretSvg = document.createElementNS(xmlns, 'svg');

        leftCaretSvg.setAttribute('xmlns', xmlns);
        leftCaretSvg.setAttribute('viewBox', '0 0 32 32');
        leftCaretSvg.setAttribute('width', '10');
        leftCaretSvg.setAttribute('height', '10');

        leftCaretSvg.appendChild(leftCaretSvgPath);

        $slick.find('.slick-prev .slick-sr-only').html(' ' + i18n.Carousel.previousSlide);

        $slick[0].querySelector('.slick-prev-icon').parentElement.replaceChild(leftCaretSvg, $slick[0].querySelector('.slick-prev-icon'));

        rightCaretSvgPath = document.createElementNS(xmlns, 'path');
        rightCaretSvgPath.setAttribute('d', 'M9.27148 27.4136L11.6315 29.7736L24.9648 16.4403L11.6315 3.10693L9.27148 5.46693L20.2448 16.4403L9.27148 27.4136Z');
        rightCaretSvgPath.setAttribute('fill', 'currentColor');

        rightCaretSvg = document.createElementNS(xmlns, 'svg');

        rightCaretSvg.setAttribute('xmlns', xmlns);
        rightCaretSvg.setAttribute('viewBox', '0 0 32 32');
        rightCaretSvg.setAttribute('width', '10');
        rightCaretSvg.setAttribute('height', '10');

        rightCaretSvg.appendChild(rightCaretSvgPath);

        $slick.find('.slick-next .slick-sr-only').html(' ' + i18n.Carousel.nextSlide);

        $slick[0].querySelector('.slick-next-icon').parentElement.replaceChild(rightCaretSvg, $slick[0].querySelector('.slick-next-icon'));

        $slick.removeAttr('role');
        $slick.removeAttr('aria-label');

        $headingDeepestElement = $instance.find('#' + $instance.attr('aria-labelledby'));

        if($headingDeepestElement.children('a[href^="#"]')) {
            $headingDeepestElement = $headingDeepestElement.children('a[href^="#"]');
        }

        $headingDeepestElement.append('<span class="visually-hidden"> (' + i18n.Carousel.carousel + ')</span>');

        $instance[0].dataset.progressiveEnhancement = 'on';
    }

    enhanceAll(self) {
        $('[data-progressive-enhancement-type="carousel"]').each(function() {
            self.enhance($(this)[0], self);
        });
    }

    revertAll(self) {
        $('[data-carousel]').each(function() {
            let $instance = $(this),
                $slick = $instance.children('.slick-slider');

            $slick.slick('unslick');
        });
    }
}// end Class

// Singleton
export default Carousel;